module.exports = __webpack_public_path__ + "img/image_slide4_1.169f8e6b.png";